module.exports = __webpack_public_path__ + "img/micromecanicien-OD-050.b2ff0908.jpg";